import { createFileRoute } from '@tanstack/react-router';
import { Stack, Tabs } from '@mantine/core';
import { IconCalendar, IconHierarchy, IconUsersGroup } from '@tabler/icons-react';
import { PageHeader } from '@/shared/components/PageHeader';
import { PlanningCalendar } from '@/features/planning/PlanningCalendar';
import { TeamWeeklyView } from '@/features/planning/TeamWeeklyView';
import { WbsTreeView } from '@/features/planning/WbsTree';

export const Route = createFileRoute('/_app/planning')({ component: PlanningPage });

function PlanningPage() {
  return (
    <Stack>
      <PageHeader title="Pianificazione" description="Calendario degli impegni, team di commessa e WBS." />
      <Tabs defaultValue="calendar" keepMounted={false}>
        <Tabs.List>
          <Tabs.Tab value="calendar" leftSection={<IconCalendar size={16} />}>Calendario</Tabs.Tab>
          <Tabs.Tab value="team" leftSection={<IconUsersGroup size={16} />}>Team commessa</Tabs.Tab>
          <Tabs.Tab value="wbs" leftSection={<IconHierarchy size={16} />}>WBS</Tabs.Tab>
        </Tabs.List>
        <Tabs.Panel value="calendar" pt="md"><PlanningCalendar /></Tabs.Panel>
        <Tabs.Panel value="team" pt="md"><TeamWeeklyView /></Tabs.Panel>
        <Tabs.Panel value="wbs" pt="md"><WbsTreeView /></Tabs.Panel>
      </Tabs>
    </Stack>
  );
}
